export const normalizeForTextOutput = (htmlOrText: string): string => {
  // First, clean up any existing newlines between </p> and <p> tags
  let cleaned = htmlOrText.replace(/<\/p>\s*\n\s*<p>/g, "</p><p>");
  // Normalize line breaks
  cleaned = cleaned.replace(/\r\n?/g, "\n");

  // Add newlines at the start of each <p> tag (except the first one)
  let withNewlines = cleaned.replace(/<p>/g, "\n<p>");
  // Remove the first newline if it was added to the beginning
  if (withNewlines.startsWith("\n")) {
    withNewlines = withNewlines.substring(1);
  }

  const normalized = withNewlines
    .replace(/<p>(.*?)<\/p>/g, (_match, content) => {
      const trimmed = String(content).trim();
      // Just return the content, newlines are already handled by <p> tags
      return trimmed;
    })
    .replace(/<br\s*\/?>/g, "\n")
    .replace(/<[^>]*>/g, "");

  return normalized;
};

export const formatEmailHtmlContent = (emailContent: string) => {
  return emailContent.replaceAll(/<p>/g, '<p style="margin:0;min-height:1em;">');
};
